<template>
  <div class="app flex-row align-items-center" id="changepasss-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="5">
          <b-card-group>
            <b-card no-body class="p-1">
              <b-card-body>
                <h3 class="text-center change-text mb-3">Đổi mật khẩu</h3>
                <b-alert
                  variant="danger"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertError"
                  @dismissed="mData.dataDefault.showDismissibleAlertError = false"
                  >{{ mData.dataDefault.error }}</b-alert
                >
                <b-alert
                  variant="success"
                  dismissible
                  :show="mData.dataDefault.showDismissibleAlertSuccess"
                  @dismissed="mData.dataDefault.showDismissibleAlertSuccess = false"
                  >{{ mData.dataDefault.success }}</b-alert
                >

                <el-form
                  :model="mData.dataForm"
                  :rules="mData.validForm"
                  ref="myForm"
                  label-width="100%"
                  label-position="top"
                  @submit.native.prevent
                >
                  <el-form-item :label="aLang.user_nameAccount" prop="account">
                    <el-input
                      prefix-icon="el-icon-user"
                      v-model.trim="mData.dataForm.account"
                      clearable
                      disabled
                      placeholder="Tài khoản"
                    ></el-input>
                  </el-form-item>

                  <el-form-item :label="aLang.user_oldPassword" prop="oldPassword">
                    <el-input
                      prefix-icon="el-icon-unlock"
                      :type="mData.dataShow.oldPass === true ? 'text' : 'password'"
                      v-model.trim="mData.dataForm.oldPassword"
                      placeholder="Mật khẩu cũ"
                    >
                      <i
                        v-if="!mData.dataShow.oldPass"
                        slot="suffix"
                        class="el-input__icon isax-eye-slash"
                        @click="mData.dataShow.oldPass = true"
                      ></i>
                      <i
                        v-if="mData.dataShow.oldPass"
                        slot="suffix"
                        class="el-input__icon isax-eye"
                        @click="mData.dataShow.oldPass = false"
                      ></i>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="aLang.user_newPassword" prop="newPassword">
                    <el-input
                      ref="newPassword"
                      prefix-icon="el-icon-lock"
                      :type="mData.dataShow.newPass === true ? 'text' : 'password'"
                      v-model.trim="mData.dataForm.newPassword"
                      placeholder="Mật khẩu mới"
                    >
                      <i
                        v-if="!mData.dataShow.newPass"
                        slot="suffix"
                        class="el-input__icon isax-eye-slash"
                        @click="mData.dataShow.newPass = true"
                      ></i>
                      <i
                        v-if="mData.dataShow.newPass"
                        slot="suffix"
                        class="el-input__icon isax-eye"
                        @click="mData.dataShow.newPass = false"
                      ></i>
                    </el-input>
                  </el-form-item>

                  <el-form-item :label="aLang.user_reEnterPass" prop="rePassword">
                    <el-input
                      prefix-icon="el-icon-lock"
                      :type="mData.dataShow.reNewPass === true ? 'text' : 'password'"
                      v-model.trim="mData.dataForm.rePassword"
                      placeholder="Nhập lại mật khẩu mới"
                    >
                      <i
                        v-if="!mData.dataShow.reNewPass"
                        slot="suffix"
                        class="el-input__icon isax-eye-slash"
                        @click="mData.dataShow.reNewPass = true"
                      ></i>
                      <i
                        v-if="mData.dataShow.reNewPass"
                        slot="suffix"
                        class="el-input__icon isax-eye"
                        @click="mData.dataShow.reNewPass = false"
                      ></i>
                    </el-input>
                  </el-form-item>

                  <el-form-item class="text-center mb-2">
                    <el-button
                      class="btn-default btn-back"
                      @click="fn_go()"
                      type="info"
                      plain
                      round
                      >{{ aLang.c_back }}</el-button
                    >

                    <el-button
                      class="btn-default"
                      @click="fn_submitForm()"
                      v-ladda
                      round
                      native-type="submit"
                      >{{ aLang.c_update }}</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import AuthBootstrapService from "../../service/AuthBootstrapService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import SharedAuthService from "../../service/SharedAuthService";
export default {
  name: "ChangePassword",
  data() {
    return {
      aLang: LanguageService.lang,
      mData: {
        dataDefault: {
          error: "",
          success: "",
          showDismissibleAlertError: false,
          showDismissibleAlertSuccess: false,
        },
        dataShow: {
          oldPass: false,
          newPass: false,
          reNewPass: false,
        },
        dataForm: {
          account: "",
          oldPassword: "",
          newPassword: "",
          rePassword: "",
        },
        validForm: {
          account: [ValidService.required],
          oldPassword: [ValidService.required],
          newPassword: [ValidService.required, ValidService.checkMinLength(6)],
          rePassword: [ValidService.required, ValidService.checkMinLength(6)],
        },
      },
    };
  },

  methods: {
    fn_submitForm() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          if (this.mData.dataForm.newPassword != this.mData.dataForm.rePassword) {
            this.mData.dataDefault.showDismissibleAlertError = true;
            this.mData.dataDefault.showDismissibleAlertSuccess = false;
            this.mData.dataDefault.error =
              LanguageService.lang.c_changePasswordErrorReEnterNew;
            MethodService.stopLadda();
            return;
          }
          if (this.mData.dataForm.newPassword == this.mData.dataForm.oldPassword) {
            this.mData.dataDefault.showDismissibleAlertError = true;
            this.mData.dataDefault.showDismissibleAlertSuccess = false;
            this.mData.dataDefault.error =
              LanguageService.lang.c_changePasswordErrorOldNew;
            MethodService.stopLadda();
            return;
          }

          AuthService.changePassword(
            this.mData.dataForm.account,
            this.mData.dataForm.oldPassword,
            this.mData.dataForm.newPassword
          )
            .then((res) => {
              // AuthService.logout("invalidAllSession")
              //   .then((res) => {
                  this.$message({
                    showClose: true,
                    message:
                      LanguageService.lang.c_changePasswordSuccess +
                      ". Bạn hãy đăng nhập lại bằng mật khẩu mới",
                    type: "success",
                    duration: 3000, //3s
                  });
                  localStorage.removeItem(`mushroom.tokens[` + window.MyConfig.hostApi + `]`);
                  SharedAuthService.clearSharedAuth();
                  AuthBootstrapService.reset();
                  setTimeout(() => {
                    this.$router.push({ name: "Auth-Login" });
                  }, 1500);
                // })
                // .catch((error) => {
                //   console.log(error);
                // });

              MethodService.stopLadda();
              return true;
            })
            .catch((error) => {
              this.mData.dataDefault.showDismissibleAlertError = true;
              this.mData.dataDefault.showDismissibleAlertSuccess = false;
              this.mData.dataDefault.error = LanguageService.lang.c_changePasswordError;
              MethodService.stopLadda();
              return false;
            });
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
      this.fn_initData();
      this.mData.dataDefault.showDismissibleAlertSucces = false;
      this.mData.dataDefault.showDismissibleAlertError = false;
    },
    async fn_initData() {
      let currentUser = MethodService.getCurrentUser();
      this.mData.dataForm.account = currentUser.account;
    },
    fn_go() {
      this.$router.go(-1);
    },
  },

  mounted() {
    this.fn_initData();
  },
  created() {},
};
</script>
<style scoped>
#changepasss-page {
  background-image: url("/img/BG-Login.png");
  background-color: var(--white);
  z-index: 4000;
  background-size: cover;
  background-repeat: no-repeat;
  background-attachment: fixed;
  background-position: right;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  -ms-background-size: cover;
}
.change-text {
  font-family: UTM AvoBold !important;
  font-style: normal;
  font-weight: bold;
  font-size: 36px;
  line-height: 53px;
  color: #ff8d02;
  text-shadow: 0px 4px 20px rgba(1, 143, 255, 0.1);
}
::v-deep .card-group {
  padding: 20px;
  background: var(--white);
  box-shadow: 0px 0px 30px rgba(0, 3, 32, 0.2);
  border-radius: 10px;
}
::v-deep .el-input__inner {
  padding-left: 40px;
  font-size: 16px;
}
::v-deep .el-input__icon.el-input__validateIcon {
  display: none !important;
}
::v-deep .el-input__prefix .el-input__icon {
  padding-top: 3px;
  padding-left: 5px;
  color: var(--orange);
  font-size: 20px;
  font-weight: bold;
}
::v-deep .el-input__prefix .el-input__icon {
  font-size: 18px !important;
  color: var(--orange);
}
</style>
